import * as Sentry from "@sentry/react";
import React from "react";

export function ErrorBoundaryWrapper({children}: {children: React.ReactNode}) {
  return <Sentry.ErrorBoundary>{children}</Sentry.ErrorBoundary>;
}
